import {
  ADD_NOTIFICATION_COOKIE,
  deleteCookieClientSide,
  getCookieMap,
} from '@utils/cookie-utils';
import { ReactNode, createContext, useContext, useEffect } from 'react';

// NOTE: add more types here as needed
export type Notification =
  | {
      id: string;
      type: 'project forked successful';
      forRoute: NotificationRoute;
      icon: ReactNode;
      message: string;
      link: string;
      linkText: string;
    }
  | {
      type: 'section project finished';
      forRoute: NotificationRoute;
      message: string;
      id: string;
    };

export type NotificationType = Notification['type'];
export type NotificationRoute = 'section-details-page';

export const NotificationQueueContext = createContext<{
  notifications: Notification[];
  setNotifications: React.Dispatch<React.SetStateAction<Notification[]>>;
}>({
  notifications: [],
  setNotifications: () => {},
});

export const useNotificationQueue = (forRoute?: NotificationRoute) => {
  const { notifications, setNotifications } = useContext(
    NotificationQueueContext,
  );

  useEffect(() => {
    const notifications = getCookieMap(document.cookie)[
      ADD_NOTIFICATION_COOKIE
    ];
    notifications ? addNotification(JSON.parse(notifications)) : null;
    deleteCookieClientSide(ADD_NOTIFICATION_COOKIE);
  }, []);

  function addNotification(notification: Notification) {
    setNotifications([...notifications, notification]);
  }

  function removeNotification(id: string) {
    setNotifications(notifications.filter((n) => n.id !== id));
  }

  return {
    notifications: notifications.filter((n) => n.forRoute === forRoute),
    addNotification,
    removeNotification,
  };
};
